import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  fetchMenusIfNeeded,
  fetchFestHistoryIfNeeded,
  selectFestHistorySubPage,
  selectFestHistory
} from "../../actions";

// import HistoricThumb from './HistoricThumb.jpg'
// import {ScheduleView} from './ScheduleView'
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { SocialView } from "../SocialView/SocialView";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";
import { CLIENT_BASE_URL } from "../../actions";

export class HistoricView extends React.Component {
  /*
  constructor (props) {
    super(props)
    this.showSchedule = this.showSchedule.bind(this)
  }
  */

  componentWillMount() {
    const { match, dispatch } = this.props;
    // console.log('componentWillMount match.params', match.params)
    dispatch(selectFestHistory(match.params.page));
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
    dispatch(selectFestHistory(match.params.page));
    dispatch(fetchFestHistoryIfNeeded(match.params.page));

    let pageID = match.params.id;
    if (typeof pageID === "undefined") {
      pageID = "programacao";
    }
    dispatch(selectFestHistorySubPage(pageID));
  }

  componentWillReceiveProps(nextProps) {
    const { match, dispatch } = nextProps;
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
      dispatch(selectFestHistory(match.params.page));
      dispatch(fetchFestHistoryIfNeeded(match.params.page));

      let pageID = match.params.id;
      if (typeof pageID === "undefined") {
        pageID = "programacao";
      }
      dispatch(selectFestHistorySubPage(pageID));
    }
  }

  renderTab(id, title) {
    // titulo e subtitulo

    // <p ref='prog_btn' className={ if activepage === 'programacao' return 'active'}>PROGRAMAÇÃO</p>

    if (id === this.props.selectedFestHistorySubPage) {
      return <p className="active">{title}</p>;
    } else {
      return <p>{title}</p>;
    }
  }

  renderSchedView() {
    const activepage = this.props.selectedFestHistorySubPage;
    const fest = this.props.fest;

    if (Object.keys(fest).length === 0) {
      return;
    }

    let custom_html = "";

    switch (activepage) {
      case "convidados":
        custom_html = fest[0].guests;
        break;
      case "premios":
        custom_html = fest[0].awards;
        break;
      case "numeros":
        custom_html = fest[0].numbers;
        break;
      case "patrocinadores":
        custom_html = fest[0].sponsors;
        break;
    }

    if (activepage === "programacao") {
      return fest[0].list_movies.map((cat, i) => {
        return (
          <div key={i} className="row">
            <div className="col-md-offset-1 col-md-3">
              {cat.thumb !== "" && (
                <img src={`${CLIENT_BASE_URL}${cat.thumb}`} />
              )}
            </div>
            <div className="col-md-7">
              <p dangerouslySetInnerHTML={{ __html: cat.list_html }} />
            </div>
          </div>
        );
      });
    } else {
      return (
        <div className="row">
          <div className="col-md-offset-1 col-md-3">
            {fest[0].list_movies.map((cat, i) => {
              if (cat.thumb === "") {
                return;
              } else {
                return (
                  <img
                    style={{ marginBottom: "20px" }}
                    src={`${CLIENT_BASE_URL}${cat.thumb}`}
                  />
                );
              }
            })}
          </div>
          <div className="col-md-7">
            <p dangerouslySetInnerHTML={{ __html: custom_html }} />
          </div>
        </div>
      );
    }
  }

  gotoPage = page => {
    this.props.history.push("/pesquisa");
  };

  render() {
    const { match, menus, fest, dispatch } = this.props;
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    const page = match.params.page;
    const proglink = `/historico/${page}/programacao`;
    const guestslink = `/historico/${page}/convidados`;
    const awardslink = `/historico/${page}/premios`;
    const numberslink = `/historico/${page}/numeros`;
    const sponsorslink = `/historico/${page}/patrocinadores`;

    let poster = "";

    if (Object.keys(fest).length !== 0 && fest[0] && fest[0].poster) {
      poster = CLIENT_BASE_URL + fest[0].poster;
    } else {
      return (
        <div>
          <HeaderView top_menus={top_menus} dispatch={dispatch} />
          <FooterLinks bottom_menus={bottom_menus} />
          <SocialView customclass="lite" style={{ marginBottom: "50px" }} />
          <FooterNote />
        </div>
      );
    }

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="historic-view" className="row">
          <div className="col-md-12 no-pad">
            <p className="left-tag">{fest[0].title}</p>
            <SearchView
              gotoPage={this.gotoPage}
              dispatch={dispatch}
              customStyle={"alignright"}
            />
          </div>
          <div className="row main-block">
            <img className="poster" src={poster} />
            <div>
              <p dangerouslySetInnerHTML={{ __html: fest[0].venues }} />
            </div>
          </div>
          <div className="col-md-12 red-dashed-no-pad" />

          <div className="col-md-offset-2 col-md-8">
            <div className="subnav">
              <Link to={proglink}>
                {this.renderTab("programacao", "PROGRAMAÇÃO")}
              </Link>
              <Link to={guestslink}>
                {this.renderTab("convidados", "CONVIDADOS")}
              </Link>
              <Link to={awardslink}>
                {this.renderTab("premios", "PRÉMIOS")}
              </Link>
              <Link to={numberslink}>
                {this.renderTab("numeros", "NÚMEROS")}
              </Link>
              <Link to={sponsorslink}>
                {this.renderTab("patrocinadores", "PATROCINADORES")}
              </Link>
            </div>
          </div>
          <div className="col-md-12 ">
            <div className="sched-view">{this.renderSchedView()}</div>
          </div>
        </div>
        <FooterLinks bottom_menus={bottom_menus} />
        <SocialView customclass="lite" />
        <FooterNote />
      </div>
    );
  }
}

HistoricView.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  fest: PropTypes.array.isRequired,
  selectedFestHistory: PropTypes.string.isRequired,
  selectedFestHistorySubPage: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const {
    selectedScope,
    getMenus,
    getFestHistory,
    selectedFestHistorySubPage,
    selectedFestHistory
  } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingFestHistory, items: fest } = getFestHistory[
    selectedFestHistory
  ] || {
    isFetchingFestHistory: true,
    items: []
  };

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingFestHistory,
    fest,
    selectedFestHistorySubPage,
    selectedFestHistory,
    selectedScope
  };
}

export default connect(mapStateToProps)(HistoricView);



// WEBPACK FOOTER //
// ./src/views/HistoricView/HistoricView.js